/*
* @Author: shihuaLiu
* @Date: 2021-11-29 14:22:48
 * @Last Modified by: shihuaLiu
 * @Last Modified time: 2022-03-02 15:00:21
*/
<template lang="pug">
  .content
    .top-content
      img.top-content-img(src="../../assets/images/banner.png")
      img.top-content-img(src="../../assets/images/1.png")
      img.top-content-img(src="../../assets/images/2.png")
      img.top-content-img(src="../../assets/images/3.png")
      img.top-content-img(src="../../assets/images/4.png")
      img.top-content-img(src="../../assets/images/5.png")
</template>

<script>
export default {
  name: 'Index',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.content{
  overflow-y: scroll;
  // padding-bottom: 159px;
}
.top-content{
  width: 100%;
  height: auto;
}
.top-content-img {
  display: inline-block;
  height: auto;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index/index.vue